export const myLeaveAdminSettingsPageMenuDef = [
  {
    id: "generalSettings",
    label: "OC_GENERAL_SETTINGS",
    roles: ["MyHR.admin"],
  },
  {
    id: "leaveFilters",
    label: "MY_LEAVE_GRANT_LEAVE_TYPES",
    roles: ["MyHR.admin"],
  },
  {
    id: "administrativeEmail",
    label: "MY_LEAVE_ADMINISTRATIVE_EMAIL",
    roles: ["MyHR.admin"],
  },
  {
    id: "subsequentRequests",
    label: "MY_LEAVE_SUBSEQUENT_REQUESTS",
    roles: ["MyHR.admin"],
  },
];
